import React, { useEffect, useState } from 'react';
import { Container, Main, SubTitle, Title, Row } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import api from './../../services/api';

export const Values = ({ query }) => {
  const [values, setValues] = useState();

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const companyValuesUrl =
        label && page_label
          ? `pages/sections/company-value/get/${label}/${page_label}`
          : `pages/sections/company-value/get/${label}`;

      try {
        const { data } = await api.get(companyValuesUrl);

        // Verificação de segurança para evitar erros quando data.data é undefined
        if (data && data.data) {
          setValues(data.data);
        } else {
          console.warn('API response data structure is invalid in Values component:', data);
          setValues({});
        }
      } catch (error) {
        console.error('Error loading company values:', error);
        setValues({});
      }
    }

    let isMoutend = true;

    if (isMoutend && query) {
      load();
    }

    return () => {
      isMoutend = false;
    };
  }, [query]);

  return (
    <Main id="companyValues" actived={values?.active}>
      <Container>
        <Title>{values?.title}</Title>
        <SubTitle>{values?.sub_title}</SubTitle>
      </Container>
      <Row>
        {values?.items?.map(value => (
          <h4>
            <FontAwesomeIcon icon={faCircleCheck} />
            {value?.title}
          </h4>
        ))}
      </Row>
    </Main>
  );
};
